<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <h5><small>Mesken Listesi</small>
      <el-button-group class="float-right" style="margin-top: -2px">
        <a class="el-button el-button--default el-button--mini"
           href="https://drive.google.com/uc?authuser=0&id=17LijESCWI8GwkAfr0-uxoWZWC-vpGuKp&export=download"
           target="_blank">Sayaç Şablon İndir</a>
        <!--a class="el-button el-button--success el-button--mini"
           @click="TelegramIndir"
           target="_blank">Telegram</a-->
        <a class="el-button el-button--warning el-button--mini"
           @click="ExcelIndir"
           target="_blank">Şablon İndir</a>
        <label for="file" type="button" class="el-button el-button--success el-button--mini">Excel Yükle</label>
        <input type="file" class="el-upload__input" id="file" accept=".xlsx,.xls,.csv,.rep"
               @change="ExcelSecimi">
        <!--el-popover
          placement="bottom"
          width="250"
          trigger="click">
          <div class="p-2">
            <el-input style="width: 220px" placeholder="Mesken No" size="mini" v-model="AMeskenId"
                      class="input-with-select">
            </el-input>
          </div>
          <el-button slot="reference" type="primary" size="mini">Mesken Ekle</el-button>
        </el-popover-->
        <el-button type="primary" size="mini" @click="fMeskenEkle">Mesken Ekle</el-button>
      </el-button-group>
    </h5>
    <el-input type="search" v-model="arama" size="mini"
              placeholder="Ad Soyad, Sayaç No, Kapı No, Telefon veya Abone No ile arayın"></el-input>
    <div class="scrollkaydir" :style="'height: '+ Height+'px'">
      <table class="table table-sm tablenohover" v-if="!Akardion"
             v-for="(m,index) in Mesken.filter(data => !arama || data.Sayac[0].SayacNo.toLowerCase().includes(arama.toLowerCase()) || data.AdSoyad.toLowerCase().includes(arama.toLowerCase()) || data.AboneNo.toLowerCase().includes(arama.toLowerCase()) || data.kNo.toLowerCase().includes(arama.toLowerCase()) || data.Telefon.toLowerCase().includes(arama.toLowerCase()))">

        <tbody>
        <tr>
          <td width="250">
            <b style="margin-left: 10px;">{{ m.AdSoyad }}</b>
          </td>
          <td>
            <b style="margin-left: 10px" class="text-black-50" v-if="m.Grup">{{ m.Grup }}</b>
          </td>
          <td>
            <div class="dDiv">
              <b style="margin-left: 10px;position:relative;">
                <a style="margin-right: 5px" size="mini" @click="KisiEkran(m.AboneNo)" class="text-mavi"><i
                  class="el-icon-user-solid"></i></a>
                {{ m.AboneNo }}</b>
              <b style="margin-left: 10px">T: {{ m.Telefon }}</b>
              <b style="margin-left: 10px">No: {{ m.kNo }}</b>
              <b style="margin-left: 10px">{{ m.m2 }} m<sup>2</sup></b>
              <b style="margin-left: 10px" class="text-kirmizi" v-if="m.Oran!=='0'">Muafiyet:{{ m.Oran }}
                <sup>%</sup></b>
              <b style="margin-left: 10px" class="text-sari" v-if="!m.oAlan">Ortak Alan Ödemiyor</b>
            </div>
          </td>
          <td width="80">
            <el-tooltip class="item" effect="dark" content="Mesken Sil" placement="top">
              <a style="margin-right: 5px" size="mini" @click="MeskenSil(m.id)" class="float-right text-kirmizi"><i
                class="el-icon-delete-solid"></i></a>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Sayaç Ekle" placement="top">
              <a style="margin-right: 5px" size="mini" @click="SayacEkle(m.id)" class="float-right text-yesil"><i
                class="el-icon-circle-plus"></i></a>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Mesken Düzenle" placement="top">
              <a style="margin-right: 5px" size="mini" @click="MeskenDuzenle(m)" class="float-right text-mavi"><i
                class="el-icon-edit"></i></a>
            </el-tooltip>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <table v-if="m.Sayac" class="table table-sm  table-bordered  BorcTable" style="margin: 0 !important;">
              <thead>
              <tr>
                <th>Sayaç No</th>
                <th>Sayaç Tipi</th>
                <th>Üretici</th>
                <th>Oda</th>
                <th>Çarpan</th>
                <th>G/Ç Sıcaklık</th>
                <th>İLk Tarih</th>
                <th>İlk Endeks</th>
                <th>Son Tarihi</th>
                <th>Son Endeks</th>
                <th>Fark</th>
              </tr>
              </thead>
              <tbody>
              <tr @click="SayacEkran(s)" v-for="s in m.Sayac">
                <td>{{ s.SayacNo }}</td>
                <td>
                  <b>{{ s.STipiTx}}</b>
                </td>
                <td>{{ s.UreticiKodu }}</td>
                <td>{{ s.OdaAdi }}</td>
                <td>{{ s.Carpan }}</td>
                <td>{{ s.GSicaklik }} - {{ s.CSicaklik }}</td>
                <td>{{ s.ITarihText }}</td>
                <td>{{ s.IEndeksText }}</td>
                <td>{{ s.STarihText }}</td>
                <td>{{ s.SEndeksText }}</td>
                <td>{{ s.Tuketim }}</td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>

        </tbody>
      </table>


      <el-collapse v-model="activeName" v-if="Akardion">
        <el-collapse-item
          v-for="(m,index) in Mesken.filter(data => !arama || data.Sayac[0].SayacNo.toLowerCase().includes(arama.toLowerCase()) || data.AdSoyad.toLowerCase().includes(arama.toLowerCase()) || data.AboneNo.toLowerCase().includes(arama.toLowerCase()) || data.kNo.toLowerCase().includes(arama.toLowerCase()) || data.Telefon.toLowerCase().includes(arama.toLowerCase()))"
          :title="m.AdSoyad+' Daire No: '+m.kNo+' - M2: '+m.m2+' - Muafiyet Oranı: '+m.Oran+'%'"
          :name="index"
          :class="!m.Sayac?'sayacyok':''">
          <template slot="title">
            <el-tooltip class="item" effect="dark" content="Mesken Düzenle" placement="top">
              <a style="margin-right: 5px" size="mini" @click="MeskenDuzenle(m)" class="float-right text-mavi"><i
                class="el-icon-edit"></i></a>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Sayaç Ekle" placement="top">
              <a style="margin-right: 5px" size="mini" @click="SayacEkle(m.id)" class="float-right text-yesil"><i
                class="el-icon-circle-plus"></i></a>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Mesken Sil" placement="top">
              <a size="mini" @click="MeskenSil(m.id)" class="float-right text-kirmizi"><i
                class="el-icon-delete-solid"></i></a>
            </el-tooltip>
            <b style="margin-left: 10px;">{{ m.AdSoyad }}</b>
            <b style="margin-left: 10px" class="text-black-50" v-if="m.Grup">{{ m.Grup }}</b>
            <div class="dDiv">
              <b style="margin-left: 10px;position:relative;">
                <a style="margin-right: 5px" size="mini" @click="KisiEkran(m.AboneNo)" class="text-mavi"><i
                  class="el-icon-user-solid"></i></a>
                {{ m.AboneNo }}</b>
              <b style="margin-left: 10px">T: {{ m.Telefon }}</b>
              <b style="margin-left: 10px">No: {{ m.kNo }}</b>
              <b style="margin-left: 10px">{{ m.m2 }} m<sup>2</sup></b>
              <b style="margin-left: 10px" class="text-kirmizi" v-if="m.Oran!=='0'">Muafiyet:{{ m.Oran }}
                <sup>%</sup></b>
              <b style="margin-left: 10px" class="text-sari" v-if="!m.oAlan">Ortak Alan Ödemiyor</b>
            </div>
          </template>
          <div>
            <table v-if="m.Sayac" class="table table-sm table-hover BorcTable" style="margin: 0 !important;">
              <thead>
              <tr>
                <th>Sayaç No</th>
                <th>Sayaç Tipi</th>
                <th>Üretici</th>
                <th>Oda</th>
                <th>Çarpan</th>
                <th>G/Ç Sıcaklık</th>
                <th>İLk Tarih</th>
                <th>İlk Endeks</th>
                <th>Son Tarihi</th>
                <th>Son Endeks</th>
                <th>Fark</th>
              </tr>
              </thead>
              <tbody>
              <tr @click="SayacEkran(s)" v-for="s in m.Sayac">
                <td>{{ s.SayacNo }}</td>
                <td :class="s.STipi==='6'?'text-kirmizi':'text-mavi'">
                  <b>{{ s.STipi === '6' ? 'Sıcak Su' : 'Kalorimetre' }}</b>
                </td>
                <td>{{ s.UreticiKodu }}</td>
                <td>{{ s.OdaAdi }}</td>
                <td>{{ s.Carpan }}</td>
                <td>{{ s.GSicaklik }} - {{ s.CSicaklik }}</td>
                <td>{{ s.ITarihText }}</td>
                <td>{{ s.IEndeksText }}</td>
                <td>{{ s.STarihText }}</td>
                <td>{{ s.SEndeksText }}</td>
                <td>{{ s.Tuketim }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </el-collapse-item>
      </el-collapse>


    </div>
    <el-dialog
      append-to-body
      :title="MMText"
      :visible.sync="MeskenModal"
      width="40%">
      <a @click="MeskenModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :rules="MDHata" :model="MDForm"
               @submit.prevent.native="MeskenKaydet"
               ref="Form">
        <el-row :gutter="24">
          <el-col :span="14">
            <el-form-item label="Ad Soyad" prop="AdSoyad">
              <el-input v-model="MDForm.AdSoyad">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Telefon No" prop="Telefon">
              <el-input v-model="MDForm.Telefon">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="3">
            <el-form-item label="Su" prop="Su">
              <el-switch v-model="MDForm.Su">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="O.Alan" prop="oAlan">
              <el-switch v-model="MDForm.oAlan">
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Muafiyet Oranı %" prop="Oran">
              <el-input v-model="MDForm.Oran">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Kapı No" prop="kNo">
              <el-input v-model="MDForm.kNo">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="M2" prop="m2">
              <el-input v-model="MDForm.m2">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Grup" prop="Grup">
              <el-input v-model="MDForm.Grup">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider>Bilgi</el-divider>
      <small>Eğer bir ortak alansa; Muafiyet oranı %100 ve O.Alan kapalı yapınız.</small><br>
      <small>Muafiyet oranı, Ortak Alanı ve Okuma ücretini etkilemez.</small><br>
      <small>Muafiyet oranı varsa muaf mesken payına dahil olmaz.</small><br>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="MeskenKaydet">Kaydet</el-button>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      v-if="SayacEkranModal"
      :title="SayacEkranModalText"
      :visible.sync="SayacEkranModal"
      width="50%">
      <a @click="SayacEkranModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>

      <table class="table table-xs">
        <thead>
        <tr>
          <th>Okuma Tarihi</th>
          <th>Üretici Kodu</th>
          <th>Giriş Sıcaklık</th>
          <th>Çıkış Sıcaklık</th>
          <th>Okuma Durumu</th>
          <th>Uyarı</th>
          <th>Okuma Endeks</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="s in SayacEkranSayacVeri" :class="s.Hata?'bg-danger':''">
          <td>{{ s.Tarih }}</td>
          <td>{{ s.UKodu }}</td>
          <td>{{ s.GSicaklik }}</td>
          <td>{{ s.CSicaklik }}</td>
          <td>{{ s.OkumaDurumu }}</td>
          <td>{{ s.Hata }}</td>
          <td>{{ s.Tuketim }}</td>
        </tr>
        </tbody>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button type="success" size="mini" @click="SayacDuzenle(SayacEkranData)">Sayaç Düzenle</el-button>
          <el-button type="danger" size="mini" @click="SayacSil(SayacEkranData.id)">Sayaç Sil</el-button>
        </el-button-group>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      :title="SayacModalText"
      :visible.sync="SayacModal"
      width="50%">

      <a @click="SayacModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :rules="SayacDataHata" :model="SayacData"
               @submit.prevent.native="SayacKaydet"
               ref="Form">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="Sayaç No" prop="SayacNo">
              <el-input v-model="SayacData.SayacNo">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Sayaç Tipi" prop="STipi">
              <el-select v-model="SayacData.STipi" filterable>
                <el-option
                  v-for="item in STipiOp"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Protokol" prop="Protocol">
              <el-select v-model="SayacData.Protocol" filterable>
                <el-option
                  v-for="item in ProtocolOp"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="İlk Endeks" prop="IEndeks">
              <el-input v-model="SayacData.IEndeks">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="İlk Okuma Tarihi" prop="ITarih">
              <el-date-picker
                v-model="SayacData.ITarih"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Son Endeks" prop="SEndeks">
              <el-input v-model="SayacData.SEndeks">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Son Okuma Tarihi" prop="STarih">
              <el-date-picker
                v-model="SayacData.STarih"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-divider>Pay Ölçer</el-divider>
          <el-col :span="6">
            <el-form-item label="Çarpan" prop="Carpan">
              <el-input v-model="SayacData.Carpan">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Oda Adı" prop="OdaAdi">
              <el-input v-model="SayacData.OdaAdi">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Sayaç Marka" prop="UreticiKodu">
              <el-input v-model="SayacData.UreticiKodu">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SayacKaydet">Kaydet</el-button>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      :title="KisiEkranModalid+' Abone Mesken Detay Ekran'"
      :visible.sync="KisiEkranModal"
      width="99%">
      <a @click="KisiEkranModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <AboneDetay v-if="KisiEkranModal" :Abone_id="KisiEkranModalid"></AboneDetay>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));
import Yukleniyor from "../../../Doc/Yukleniyor";
import {HotTable} from '@handsontable/vue';
import AboneDetay from "../../../../pages/_Sayac/Abone/AboneDetay";

export default {
  components: {AboneDetay, Yukleniyor, HotTable},
  props: ['Mesken', 'Bina', 'Excel', 'ExcelTelegram'],
  data() {
    return {
      Height: window.innerHeight - 120,
      arama: '',
      activeName: null,
      SayacVeri: null,
      SayacVeriModal: false,
      Akardion: false,
      lo: false,
      AMeskenId: null,
      MeskenModal: false,
      SayacModal: false,
      SayacEkranModal: false,
      SayacEkranModalText: null,
      MMText: null,
      MDForm: {
        AdSoyad: null,
        Telefon: null,
        Oran: null,
        kNo: null,
        oAlan: null,
        m2: null,
        AMeskenId: null,
        id: null,
        Su: true
      },
      MDHata: {
        AdSoyad: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        kNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        m2: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      CekData: {
        Mesken_id: this.AMeskenId,
        VT: this.Bina.AVT,
        Bina_id: this.Bina.ABinaId
      },
      SayacData: {
        UreticiKodu: null,
        OdaAdi: null,
        Carpan: null,
        SayacNo: null,
        Protocol: 2,
        STipi: 4,
        IEndeks: null,
        ITarih: null,
        SEndeks: null,
        STarih: null,
        id: null,
        Mesken_id: null
      },
      SayacDataHata: {
        SayacNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        IEndeks: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        ITarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        SEndeks: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        STarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      STipiOp: [{Adi: 'Kalorimetre', id: '4'}, {Adi: 'Sıcak Su', id: '6'}, {Adi: 'Soğuk Su', id: '7'}, {
        Adi: 'Elektrik',
        id: '8'
      }],
      ProtocolOp: [{Adi: 'M-Bus Adres', id: '1'}, {Adi: 'Standart M-Bus', id: '2'}, {
        Adi: 'Teksan',
        id: '3'
      }, {Adi: 'General(14 Hane)', id: '4'}],
      SayacModalText: 'Sayaç Düzenle',
      SayacEkranData: null,
      SayacEkranSayacVeri: null,
      SayacOkumaSayacVeri: null,
      KisiEkranModal: false,
      KisiEkranModalid: null
    }
  },
  methods: {
    KisiEkran(id) {
      this.KisiEkranModal = true;
      this.KisiEkranModalid = id;
    },
    ExcelSecimi(evt) {
      const files = evt.target.files;
      if (files && files[0]) this._file(files[0]);
    },
    _file(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, {raw: false, header: 1, dateNF: "DD-MM-YYYY"});
        this.SayacVeri = data;
        this.cols = make_cols(ws['!ref']);
        this.SayacVeriGonder();
      };

      reader.readAsBinaryString(file);
    },
    fMeskenEkle() {
      this.MDForm = {
        AdSoyad: '',
        Oran: '0',
        kNo: '',
        oAlan: true,
        Telefon: '',
        m2: '100',
        Su: false,
        id: null
      };
      this.MMText = 'Mesken Ekle';
      this.MeskenModal = true
    },
    SayacVeriGonder() {
      this.lo = true;
      // this.$alert('İşlem tamamlanana kadar bekleyiniz.', 'Veri İşleniyor', {
      //   confirmButtonText: 'Bekleyiniz',
      //   showConfirmButton: true,
      // });
      //$(".el-message-box__btns button").remove();
      //this.SayacVeriModal = true;
      this.$store.dispatch("Post", {
        Data: this.SayacVeri,
        path: '_enerji/sayacveri/' + this.Bina.id
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            //this.SayacOkumaSayacVeri = response.Liste
            this.$message.success(response.Mesaj);
            this.$emit('Yenile', true);
          } else {
            this.$message.warning(response.Mesaj);
          }
        })
    },
    SayacDuzenle(data) {
      this.SayacModalText = 'Sayaç Düzenle';
      this.SayacModal = true;
      this.SayacData = {
        UreticiKodu: data.UreticiKodu,
        OdaAdi: data.OdaAdi,
        Carpan: data.Carpan,
        SayacNo: data.SayacNo,
        Protocol: data.Protocol,
        STipi: data.STipi,
        IEndeks: data.IEndeks,
        ITarih: data.ITarih,
        SEndeks: data.SEndeks,
        STarih: data.STarih,
        Mesken_id: data.Mesken_id,
        Grup: data.Grup,
        id: data.id
      }
    },
    SayacEkran(data) {
      this.SayacEkranModal = true;
      this.SayacEkranModalText = data.SayacNo + " Sayaç Ekran";
      this.SayacEkranData = data;

      this.$store.dispatch("Get", {path: '_enerji/sayacveri/' + data.id})
        .then(response => {
          if (response.Durum == "OK") {
            this.SayacEkranSayacVeri = response.Liste
          } else {
            this.$message.warning(response.Mesaj);
          }
        })
    },
    ExcelIndir() {

      const ws = XLSX.utils.json_to_sheet(this.Excel);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
      ];

      wb.Props = {
        Title: this.Bina.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Bina.Adi,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.Bina.Adi);
      XLSX.writeFile(wb, this.Bina.Adi + ".xlsx");
    },
    TelegramIndir() {


      this.lo = true;
      this.$store.dispatch("Get", {
        Url: 'https://sendmail.yapifenenerji.net/telegramxls.php?Bina_id=' + this.Bina.id,
        path: ''
      })
        .then(response => {
          this.lo = false
          if (response == '1') {
            this.$message.success('Telegram yüklendi')
          } else {
            this.$message.error('Telegram yüklenemedi')
          }
        });


    },
    SayacEkle(Mesken_id) {
      this.SayacModalText = 'Sayaç Ekle';
      this.SayacModal = true;
      this.SayacData = {
        Carpan: null,
        SayacNo: null,
        Protocol: '2',
        STipi: '4',
        IEndeks: null,
        ITarih: new Date(),
        SEndeks: null,
        Grup: null,
        STarih: new Date(),
        Mesken_id: Mesken_id,
        id: null
      }
    },
    SayacKaydet() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Put", {
            ...this.SayacData,
            path: '_enerji/sayac/'
          })
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.SayacModal = false;
                this.$message.success(response.Mesaj)
                this.$emit('Yenile', true);
              } else {
                this.$message.error(response.Mesaj)
              }
            });

        }
      })
    },
    SayacSil(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.SayacSilOnay(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    SayacSilOnay(id) {
      this.$store.dispatch("Delete", {path: '_enerji/sayac/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.MeskenModal = false;
            this.$message.success(response.Mesaj)
            this.$emit('Yenile', true);
          } else {
            this.$message.warning(response.Mesaj);
          }
        })
    },
    MeskenDuzenle(MBilgi) {
      this.MDForm = {
        AdSoyad: MBilgi.AdSoyad,
        Oran: MBilgi.Oran,
        Grup: MBilgi.Grup,
        kNo: MBilgi.kNo,
        oAlan: MBilgi.oAlan,
        Telefon: MBilgi.Telefon,
        m2: MBilgi.m2,
        AMeskenId: MBilgi.AMeskenId,
        Su: MBilgi.Su,
        id: MBilgi.id
      };
      this.MMText = 'Mesken Düzenle';
      this.MeskenModal = true
    },
    MeskenSil(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.MeskenSilOnay(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    MeskenSilOnay(id) {

      this.$store.dispatch("Delete", {path: '_enerji/mesken/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.MeskenModal = false;
            this.$message.success(response.Mesaj)
            this.$emit('Yenile', true);
          } else {
            this.$message.warning(response.Mesaj);
          }
        })
    },
    MeskenCek() {

      if (this.AMeskenId) {

        this.CekData.Mesken_id = this.AMeskenId;
        this.$store.dispatch("Put", {
          ...this.CekData,
          path: '_enerji/entegrasyon/'
        })
          .then(response => {
            if (response.Durum == 'OK') {
              this.MDForm = {
                AdSoyad: response.Bilgi.AdSoyad,
                Telefon: response.Bilgi.Telefon,
                Oran: 0,
                kNo: response.Bilgi.kNo,
                oAlan: true,
                Su: true,
                m2: response.Bilgi.m2,
                AMeskenId: this.AMeskenId,
                id: null
              };
              this.MMText = 'Yeni Mesken Ekle';
              this.MeskenModal = true
            } else {
              this.$message.error(response.Mesaj)
            }
          })
      }
    },
    MeskenKaydet() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          if (this.MDForm.id) {
            //DÜZENLE
            this.$store.dispatch("Put", {
              ...this.MDForm,
              path: '_enerji/mesken/' + this.MDForm.id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.MeskenModal = false;
                  this.$message.success(response.Mesaj)
                  this.$emit('Yenile', true);
                }
              });
          } else {
            //EKLE
            this.$store.dispatch("Post", {
              ...this.MDForm,
              path: '_enerji/mesken/' + this.Bina.id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.MeskenModal = false;
                  this.$message.success(response.Mesaj)
                  this.$emit('Yenile', true);
                } else {
                  this.$message.error(response.Mesaj)
                }
              });

          }
        }
      })
    },

  }
}
</script>


<style scoped>
@import '~handsontable/dist/handsontable.full.css';
</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/Comp/EsayacMeskenListesi.vue